import Mutations from '../../odata/mutations';

export default { ...new Mutations('subCompetency'), ...new Mutations('subCompetencies') };
